import React from 'react';
import RightIcon from '@/assets/PaymentDlg/right.svg';
import SmallRightIcon from '@/assets/PaymentDlg/smallright.svg';

const ProductList = ({ small = false }) => {
  const list = ['PDF Editor Cloud', 'PDF Editor for Windows', 'PDF Editor for Mac', 'PDF Editor for Mobile'];
  return (<dl className={`role-list ${small ? 'small' : ''}`}>
    {list.map((item, index) => (<dd key={`prod_${index}`}><img src={small ? SmallRightIcon : RightIcon} alt={item} />
      <span>{item}</span>
    </dd>))}
  </dl>);
};
export default ProductList;